import { render, staticRenderFns } from "./FrontEnd.vue?vue&type=template&id=04335480"
import script from "./FrontEnd.vue?vue&type=script&setup=true&lang=js"
export * from "./FrontEnd.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FrontEnd.vue?vue&type=style&index=0&id=04335480&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports